{
  "header": {
    "brandName": "SmartASS Agents"
  },
  "hero": {
    "badge": "KI-gestützte Workflow-Automatisierung",
    "titleLine1": "Automatisieren Sie Ihr Geschäft",
    "titleLine2": "Ohne Code zu schreiben",
    "description": "Erstellen Sie intelligente KI-Workflows visuell. Verbinden Sie Ihre Tools, automatisieren Sie wiederkehrende Aufgaben und lassen Sie smarte KI-Agenten Kundengespräche führen — alles auf einer Plattform.",
    "ctaDashboard": "Zum Dashboard",
    "ctaStart": "Kostenlos starten",
    "benefit1": "Einrichtung in 5 Minuten",
    "benefit2": "Kostenlos starten",
    "benefit3": "Keine Einrichtungsgebühren",
    "scrollToExplore": "Scrollen zum Entdecken"
  },
  "stats": {
    "fasterWorkflow": "Schnellere Workflow-Erstellung",
    "hoursSaved": "Eingesparte Stunden pro Monat",
    "automated": "Automatische Verfügbarkeit",
    "uptime": "Verfügbarkeitsgarantie"
  },
  "features": {
    "tag": "Funktionen",
    "title": "Alles was Sie zur Automatisierung brauchen",
    "subtitle": "Leistungsstarke Funktionen für Geschäftsanwender, nicht für Entwickler. Erstellen, bereitstellen und skalieren Sie mit Vertrauen.",
    "visualBuilder": "Visueller Workflow-Builder",
    "visualBuilderDesc": "Erstellen Sie leistungsstarke Automatisierungen durch einfaches Drag-and-Drop. Keine Programmierung erforderlich — jeder kann in Minuten ausgefeilte Workflows erstellen.",
    "visualBuilderTag": "No-Code",
    "aiUnderstands": "KI die versteht",
    "aiUnderstandsDesc": "Unsere intelligenten KI-Agenten lernen aus dem Kontext und merken sich Gespräche. Erhalten Sie smarte Antworten, die für Ihr Unternehmen wirklich Sinn ergeben.",
    "aiUnderstandsTag": "KI-gestützt",
    "integrations": "Nahtlose Integrationen",
    "integrationsDesc": "Verbinden Sie Ihre Lieblingstools sofort. E-Mail, Kalender, CRMs und mehr — alles arbeitet automatisch zusammen.",
    "integrationsTag": "Alles verbinden",
    "security": "Enterprise-Sicherheit",
    "securityDesc": "Banklevel-Verschlüsselung und DSGVO-Konformität integriert. Ihre Daten bleiben mit mehrschichtiger Sicherheitsarchitektur geschützt.",
    "securityTag": "Sicher"
  },
  "howItWorks": {
    "tag": "So funktioniert's",
    "title": "In Minuten einsatzbereit",
    "subtitle": "Drei einfache Schritte, um Ihre Arbeit zu transformieren",
    "step": "SCHRITT",
    "step1Title": "Verbinden Sie Ihre Tools",
    "step1Desc": "Verknüpfen Sie Ihre bestehenden Business-Tools mit nur wenigen Klicks. Wir unterstützen alle wichtigen Plattformen.",
    "step2Title": "Erstellen Sie Ihren Flow",
    "step2Desc": "Per Drag-and-Drop Ihren perfekten Workflow erstellen. Keine technischen Kenntnisse erforderlich.",
    "step3Title": "Lassen Sie die KI arbeiten",
    "step3Desc": "Aktivieren Sie Ihren Flow und sehen Sie zu, wie die KI Aufgaben automatisch erledigt, rund um die Uhr."
  },
  "useCases": {
    "tag": "Anwendungsfälle",
    "title": "Automatisieren Sie was zählt",
    "subtitle": "Vom Kundensupport bis zum Vertrieb — sehen Sie, wie Teams wie Ihres jeden Tag Zeit sparen",
    "support": "Kundensupport",
    "supportDesc": "Automatisieren Sie Antworten, leiten Sie Anfragen intelligent weiter und lösen Sie Probleme schneller mit KI-gestütztem Chat.",
    "supportBenefit1": "24/7 Verfügbarkeit",
    "supportBenefit2": "Sofortige Antworten",
    "supportBenefit3": "Intelligente Weiterleitung",
    "booking": "Terminbuchung",
    "bookingDesc": "Lassen Sie Kunden automatisch Termine buchen. Kein E-Mail-Hin-und-Her, nur nahtlose Terminplanung.",
    "bookingBenefit1": "Kalender-Sync",
    "bookingBenefit2": "Auto-Erinnerungen",
    "bookingBenefit3": "Multi-Zeitzone",
    "email": "E-Mail-Automatisierung",
    "emailDesc": "Versenden Sie personalisierte E-Mails im großen Stil. Von Kampagnen bis zu Transaktionsnachrichten — alles automatisiert.",
    "emailBenefit1": "Vorlagen",
    "emailBenefit2": "Personalisierung",
    "emailBenefit3": "Tracking",
    "leads": "Lead-Qualifizierung",
    "leadsDesc": "Qualifizieren und pflegen Sie Leads automatisch. Die KI identifiziert heiße Interessenten, damit sich Ihr Team auf den Abschluss konzentrieren kann.",
    "leadsBenefit1": "Intelligente Bewertung",
    "leadsBenefit2": "Auto-Nachverfolgung",
    "leadsBenefit3": "CRM-Sync"
  },
  "testimonials": {
    "tag": "Referenzen",
    "title": "Von Teams überall geliebt",
    "subtitle": "Sehen Sie, was Geschäftsführer über uns sagen",
    "quote1": "Wir haben unsere Antwortzeit von Stunden auf Sekunden reduziert. Unsere Kunden sind begeistert!",
    "quote2": "Der visuelle Workflow-Builder ist ein Gamechanger. Ich habe unseren gesamten Lead-Prozess an einem Nachmittag erstellt.",
    "quote3": "Endlich KI-Automatisierung, die Kontext wirklich versteht. Es fühlt sich an wie ein intelligenter Assistent."
  },
  "enterprise": {
    "tag": "Enterprise-fähig",
    "title": "Für Skalierung & Sicherheit gebaut",
    "description": "Enterprise-Grade-Infrastruktur, die mit Ihrem Unternehmen wächst. Multi-Tenant-Architektur, DSGVO-Konformität und 99,9% Verfügbarkeit garantiert.",
    "feature1": "Multi-Tenant-Datenisolierung",
    "feature2": "Rollenbasierte Zugriffskontrolle",
    "feature3": "SOC 2 Typ II konform",
    "feature4": "Ende-zu-Ende-Verschlüsselung",
    "feature5": "Dedizierter Support",
    "microservices": "14 Microservices",
    "workingTogether": "Arbeiten zusammen"
  },
  "cta": {
    "title": "Bereit, Ihren Workflow zu transformieren?",
    "subtitle": "Schließen Sie sich Tausenden von Unternehmen an, die ihre Abläufe mit SmartAss AI automatisieren. Starten Sie kostenlos und skalieren Sie nach Bedarf.",
    "ctaDashboard": "Zum Dashboard",
    "ctaStart": "Kostenlos starten",
    "contactSales": "Vertrieb kontaktieren"
  },
  "footer": {
    "copyright": "© {{year}} Alle Rechte vorbehalten.",
    "tagline": "Enterprise-Grade KI-Workflow-Automatisierung"
  }
}
